import { useState } from "react";
import { Instagram, Mail, Truck, Heart, MapPin, CreditCard } from "lucide-react";
import { CustomOrderDialog } from "./CustomOrderDialog";

export const Footer = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer
        id="personalizados"
        data-testid="footer"
        className="bg-slate-900 text-slate-300"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          {/* Top: brand block + columns */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
            {/* Brand */}
            <div>
              <h3 className="font-serif text-2xl md:text-3xl text-white tracking-tight">
                acuadros<span className="text-[#E85A3C]">.co</span>
              </h3>
              <p className="mt-3 text-sm text-slate-400 max-w-xs leading-relaxed">
                El arte de ser extraordinario. Cuadros personalizados en MDF
                que capturan momentos únicos.
              </p>
              <a
                href="https://instagram.com/somosacuadros"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="mt-5 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[#E85A3C] transition-colors duration-300"
              >
                <Instagram className="h-4 w-4" strokeWidth={1.75} />
                @somosacuadros
              </a>
              <a
                href="https://www.google.com/maps/search/?api=1&query=Av+10+%2317-45+Los+Patios+Norte+de+Santander"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address-link"
                className="mt-3 flex items-start gap-2 text-sm text-slate-400 hover:text-[#E85A3C] transition-colors duration-300 max-w-xs"
              >
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" strokeWidth={1.75} />
                <span>
                  Av 10 #17-45, Los Patios
                  <br />
                  Norte de Santander, Cúcuta
                </span>
              </a>
            </div>

            {/* Personalizados */}
            <div>
              <h4 className="text-xs uppercase tracking-[0.22em] text-slate-400 mb-4">
                Cuadros personalizados
              </h4>
              <p className="text-sm text-slate-300 leading-relaxed">
                ¿Tienes una foto especial? Convertimos tus recuerdos en cuadros
                en MDF, listos para colgar.
              </p>
              <button
                type="button"
                onClick={() => setOpen(true)}
                data-testid="footer-custom-cta"
                className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#E85A3C] hover:text-white transition-colors duration-300"
              >
                <Heart className="h-4 w-4" strokeWidth={1.75} />
                Solicitar el mío
              </button>
              <div
                data-testid="footer-sistecredito"
                className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-800/70 border border-slate-700 text-xs text-slate-200"
              >
                <CreditCard className="h-3.5 w-3.5 text-[#E85A3C]" strokeWidth={2} />
                Paga con Sistecrédito
              </div>
            </div>

            {/* Soporte */}
            <div>
              <h4 className="text-xs uppercase tracking-[0.22em] text-slate-400 mb-4">
                Soporte
              </h4>
              <ul className="space-y-3 text-sm">
                <li>
                  <a
                    href="#envios"
                    data-testid="footer-shipping-link"
                    className="inline-flex items-center gap-2 text-slate-300 hover:text-[#E85A3C] transition-colors duration-300"
                  >
                    <Truck className="h-4 w-4" strokeWidth={1.75} />
                    Envíos a todo Colombia
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:hola@acuadros.co"
                    data-testid="footer-contact-link"
                    className="inline-flex items-center gap-2 text-slate-300 hover:text-[#E85A3C] transition-colors duration-300"
                  >
                    <Mail className="h-4 w-4" strokeWidth={1.75} />
                    hola@acuadros.co
                  </a>
                </li>
                <li>
                  <a
                    href="#terminos"
                    data-testid="footer-terms-link"
                    className="text-slate-300 hover:text-[#E85A3C] transition-colors duration-300"
                  >
                    Términos y condiciones
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-slate-500">
              © {new Date().getFullYear()} acuadros.co · Cúcuta, Colombia.
            </p>
            <p className="text-xs text-slate-500">
              El arte de ser extraordinario.
            </p>
          </div>
        </div>
      </footer>

      <CustomOrderDialog open={open} onOpenChange={setOpen} />
    </>
  );
};
